import React, { useEffect, useRef, useState } from 'react';
import '../styles/History.css';
import { FaPlusCircle, FaSearch } from 'react-icons/fa';
import { RiCheckFill, RiCloseFill, RiFileShield2Line, RiToggleFill, RiToggleLine } from 'react-icons/ri';
import { useSlideout } from '../../../hooks/SlideoutContext';
import { IoMdRefresh } from 'react-icons/io';
import axios from 'axios';
import config from '../../../constants/config';
import axiosPost from '../../../helper/axios-helper';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function History() {
    const [historyItems, setHistoryItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const { openSlideout, closeSlideout } = useSlideout();

    const fetchHistory = () => {
        
        axiosPost('about/history/fetch', {}, {}, (data) => {
            const { success, response } = data;
            if (success) {
                setHistoryItems(data.data);

                console.log(data.data)
            }
        })
    }

    useEffect(() => {
        fetchHistory();
    }, []);


    const EditHistoryItem = ({ historyItem, fetchHistory }) => {
        const { closeSlideout } = useSlideout();
        const [itemData, setItemData] = useState({
            id: historyItem.id,
            title: historyItem.title,
            text: historyItem.text,
            year: historyItem.year,
            active: historyItem.active,
            image: historyItem.image
        });

        const [selectedImageFile, setSelectedImageFile] = useState(null);
        const [selectedImagePreview, setSelectedImagePreview] = useState(historyItem.image);
        const fileInputRef = useRef(null);

        // Handle input changes
        const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setItemData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value
            }));
        };

        // Handle file selection
        const handleImageChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                const imageUrl = URL.createObjectURL(file); // Create a temporary preview
                setSelectedImageFile(file);
                setSelectedImagePreview(imageUrl);
            }
        };

        // Open file input
        const handleSelectImage = () => {
            fileInputRef.current.click();
        };

        // Handle save changes
        const handleSaveChanges = () => {
            const formData = new FormData();
            
            // Check if this is an update or a new item
            const isNewItem = !itemData.id;
            
            // Only append ID if it's an update
            if (!isNewItem) {
                formData.append("id", itemData.id);
            }
            
            formData.append("title", itemData.title);
            formData.append("text", itemData.text);
            formData.append("year", itemData.year);
            
            if (selectedImageFile) {
                formData.append("image", selectedImageFile);
            }
            
            // Determine the endpoint based on whether it's a new item or an update
            const endpoint = isNewItem 
                ? "admin/history/add" 
                : "admin/history/update";
            
            axios.post(config.api.url + endpoint, formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: "b8GjLbLHDX9isF10ptWj",
                    "Content-Type": "multipart/form-data"
                }
            })
            .then((json) => {
                const { success, response } = json.data;
                if (success) {
                    closeSlideout();
                    fetchHistory();
                } else {
                    console.log("Error:", response);
                }
            })
            .catch((error) => {
                console.error(isNewItem ? "Add error:" : "Update error:", error);
            });
        };

        return (
            <div className="EditHistoryItemContainer">
                <div className="EditHistoryItemForm">
                    <div className="EditHistoryItemFormGroup">
                        <label>Title</label>
                        <input
                            type="text"
                            name="title"
                            value={itemData.title}
                            onChange={handleChange}
                            placeholder="Enter title"
                        />
                    </div>

                    <div className="EditHistoryItemFormGroup">
                        <label>Year</label>
                        <input
                            type="text"
                            name="year"
                            value={itemData.year}
                            onChange={handleChange}
                            placeholder="Enter year"
                        />
                    </div>

                    <div className="EditHistoryItemFormGroup">
                        <label>Text</label>
                        <ReactQuill
                            theme="snow"
                            value={itemData.text}
                            onChange={(content) => {
                                setItemData(prev => ({
                                    ...prev,
                                    text: content
                                }));
                            }}
                            modules={{
                                toolbar: [
                                    ['bold', 'italic', 'underline', 'strike'],
                                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                    ['link'],
                                    ['clean']
                                ],
                            }}
                            placeholder="Enter text content"
                            className="HistoryTextEditor"
                        />
                    </div>

                    {/* <div className="EditHistoryItemFormGroup">
                        <label>Active</label>
                        <div className="ToggleSwitch">
                            <input
                                type="checkbox"
                                name="active"
                                checked={itemData.active === 1}
                                onChange={handleChange}
                                id={`active-toggle-${itemData.id}`}
                            />
                            <label htmlFor={`active-toggle-${itemData.id}`}>
                                {itemData.active === 1 ? 'Active' : 'Inactive'}
                            </label>
                        </div>
                    </div> */}

                    <div className="EditHistoryItemFormGroup">
                        <label>Image</label>
                        <div className="ImageUploadContainer">
                            <div
                                className="ImagePreview"
                                style={{
                                    backgroundImage: `url(${selectedImagePreview})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    width: '100%',
                                    height: '200px',
                                    borderRadius: '4px',
                                    marginBottom: '10px'
                                }}
                            />
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={handleImageChange}
                                style={{ display: 'none' }}
                                accept="image/*"
                            />
                            <button
                                type="button"
                                onClick={handleSelectImage}
                                className="SelectImageButton"
                            >
                                Select Image
                            </button>
                        </div>
                    </div>

                    <div className="EditHistoryItemActions">
                        <button
                            type="button"
                            onClick={closeSlideout}
                            className="CancelButton"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={handleSaveChanges}
                            className="SaveButton"
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='HistoryDashContainer'>
            <div className='HistoryDashHeader'>
                <div className='HistoryDashHeaderTitle'>
                    <h2>History Timeline</h2>
                    <p>Manage CANTO's historical milestones</p>
                </div>
                <div className='HistoryDashHeaderActions'>
                    <div className='HistoryDashHeaderActionsSearch'>
                        <FaSearch style={{ fontSize: 14 }} />
                        <input type="text" placeholder="Search history items..." />
                    </div>
                    <button 
                        className='HistoryDashHeaderActionsRefresh'
                        onClick={fetchHistory}
                        disabled={loading}
                    >
                        <IoMdRefresh style={{ fontSize: 16 }} />
                        <span>Refresh</span>
                    </button>
                    <button 
                        className='HistoryDashHeaderActionsAdd'
                        onClick={() => {
                            // Handle adding new history item
                            openSlideout({
                                title: 'Add New History Item',
                                content: <EditHistoryItem 
                                    historyItem={{
                                        id: '',
                                        title: '',
                                        text: '',
                                        year: '',
                                        image: '',
                                        active: 1
                                    }} 
                                    fetchHistory={fetchHistory}
                                />
                            });
                        }}
                    >
                        <FaPlusCircle style={{ fontSize: 16 }} />
                        <span>Add New</span>
                    </button>
                </div>
            </div>

            <div className='HistoryDashContent'>
                <div className='HistoryContentNavigation'>
                    <div className='HistoryContentNavigationItem First'>Status</div>
                    <div className='HistoryContentNavigationItem Image'>Image</div>
                    <div className='HistoryContentNavigationItem Title'>Title</div>
                    <div className='HistoryContentNavigationItem Year'>Year</div>
                    <div className='HistoryContentNavigationItem Text'>Text</div>
                </div>
                <div className='HistoryScroll'>
                    {historyItems.map((item) => (
                        <div className='HistoryItem' key={item.id}>
                            <div className="HistoryItemDetailsText First Active">
                                <span className={`HistoryItemDetailsTextOption Circle ${item.active > 0 ? 'Success' : 'Error'}`}>
                                    {item.active > 0
                                    ? <RiCheckFill style={{ fontSize: 12 }} />
                                    : <RiCloseFill style={{ fontSize: 12 }} />
                                    }
                                </span>
                            </div>
                            <div className="HistoryItemDetailsText Image">
                                <div 
                                    className="HistoryItemDetailsTextImage" 
                                    style={{ backgroundImage: `url(${item.image})` }} 
                                />
                            </div>
                            <div className="HistoryItemDetailsText Title Bold">{item.title}</div>
                            <div className="HistoryItemDetailsText Year">{item.year}</div>
                            <div className="HistoryItemDetailsText Text">
                                {item.text.length > 100 ? `${item.text.substring(0, 100)}...` : item.text}
                            </div>

                            <div className="HistoryItemOptions">
                                <a 
                                    onClick={() => {
                                        // Toggle active status
                                        console.log(`Toggle active status for history item ${item.id}`);
                                        // In a real implementation, this would update the item's active status
                                    }} 
                                    className={`HistoryItemOptionsButton ${item.active ? 'DeleteInverted' : 'AddInverted'}`}
                                >
                                    {item.active > 0
                                    ? <RiToggleFill style={{ fontSize: 14 }} />
                                    : <RiToggleLine style={{ fontSize: 14 }} />
                                    }
                                    <span className="HistoryItemOptionsButtonText">
                                        {item.active > 0 ? 'Deactivate' : 'Activate'}
                                    </span>
                                </a>

                                <a 
                                    onClick={() => {
                                        openSlideout({
                                            title: 'Edit History Item',
                                            content: <EditHistoryItem historyItem={item} fetchHistory={fetchHistory}/>
                                        });
                                    }} 
                                    className="HistoryItemOptionsButton Edit"
                                >
                                    <RiFileShield2Line style={{ fontSize: 14 }} />
                                    <span className="HistoryItemOptionsButtonText">Edit</span>
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='HistoryPaginationWrapper'>
                    {/* Pagination will be added here when needed */}
                </div>
            </div>
        </div>
    );
}
